export default {
	codenames: {
		// Siehe en/codenames.ts.
		willBeCalled: "Heißt dann „{name}“",
		duplicateLabelHint: "eine andere Entität nutzt diese Bezeichnung bereits",
		manualHint: "Manuell gesetzt — Änderungen an der Terminologie benennen ihn nicht um.",
		useDerived: "Wieder aus der Bezeichnung ableiten",
		manualUseDerived: "Manuell gesetzt — wieder aus der Bezeichnung ableiten",
		cleanup: {
			title: "Code-Namen aufräumen",
			description:
				"Leitet jeden Code-Namen neu aus der Terminologie ab und lässt keinen manuell gesetzten übrig. Was noch keine Terminologie hat, bekommt seinen Code-Namen als englische Bezeichnung. Vordefinierte Datenobjekte und Entitäten aus Abhängigkeiten bleiben unangetastet.",
			check: "Auf Änderungen prüfen",
			apply: "{count} Änderung anwenden | {count} Änderungen anwenden",
			none: "Alle Code-Namen folgen ihrer Terminologie, und keiner ist manuell gesetzt.",
			applied: "{count} Entität aufgeräumt. | {count} Entitäten aufgeräumt.",
			notChecked: "Noch nicht geprüft",
			notCheckedHint:
				"Prüfen Sie auf Änderungen, um vorab zu sehen, welche Code-Namen umbenannt würden.",
			notCheckedReadOnly:
				"Wer dieses Projekt bearbeiten darf, kann prüfen, welche Code-Namen umbenannt würden.",
			releasesManual: "Manuell gesetzt",
			releasesManualHint:
				"Der Name wurde manuell gesetzt. Das Aufräumen gibt ihn frei, sodass Änderungen an der Terminologie ihn wieder umbenennen.",
			createsTerm: "Neuer Begriff",
			createsTermHint:
				"Es hat noch keine Terminologie. Das Aufräumen legt einen Begriff mit diesem Code-Namen als englischer Bezeichnung an und markiert ihn als noch nicht geprüft.",
			kinds: {
				dataobject: "Datenobjekte",
				type: "Typen",
				attribute: "Attribute",
				relation: "Beziehungen",
				type_value: "Typwerte",
			},
		},
	},
};
